import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {STATES, routerConfigFn} from './app.routes';
import {UIRouterModule, UIView} from '@uirouter/angular';
import {PagesModule} from './pages/pages.module';
import {HttpClientModule} from '@angular/common/http';
import { InViewportModule } from 'ng-in-viewport';



@NgModule({
  declarations: [],
  imports: [
    BrowserModule,
    InViewportModule,
    HttpClientModule,
    UIRouterModule.forRoot({
      states: STATES,
      otherwise: '/',
      useHash: true,
      config: routerConfigFn
    }),
    PagesModule
  ],
  providers: [],
  bootstrap: [UIView]
})
export class AppModule { }

